import * as helpers from './helpers';

export default function menu() {
    var mobile_toggle = $('nav.mobile-toggle a');
    var menu = $('nav.main');

    mobile_toggle.on('click', function(e) {
        e.preventDefault();

        menu.toggleClass('mobile-active');
        mobile_toggle.text(function(i, text) {
            return text == 'Menu' ? 'Close' : 'Menu';
        });
    });

    menu.on('nav-close', function() {
        menu.removeClass('mobile-active');
        mobile_toggle.text('Menu');
    });

    $(window).on('resize', function() {
        if (helpers.breakpoint() == 'desktop-wide') {
            menu.trigger('nav-close');
        }
    });

    // hide footer nav when js works, as we'll just expand the header nav
    $('footer nav').remove();
};
